
export const isUrl = (url) => 'string' === typeof url && (url.startsWith('http') || url.startWith('/'));
export const isData = (obj) => 'object' === typeof obj && null !== obj;

//
export const parseUrl = (url) => {
    const u = new URL(url);
    const params = new URLSearchParams(u.searchParams.toString());
    const result = {};
    for (const [key, value] of params.entries()) {
        const isArray = key.endsWith('[]');
        const normalizedKey = isArray ? key.slice(0, -2) : key;
        if (isArray) {
            // 如果鍵已存在於物件且是陣列，推入新值
            result[normalizedKey] = result[normalizedKey] || [];
            result[normalizedKey].push(value);
        } else if (result[normalizedKey] !== undefined) {
            // 如果鍵已存在於物件且不是陣列，將值轉為陣列
            result[normalizedKey] = [].concat(result[normalizedKey], value);
        } else {
            result[normalizedKey] = value;
        }
    }
    return result;
};

//
export const dataToSearchParams = (data) => {
    //object解析為 param string 再轉為 object
    const params = new URLSearchParams();
    for (const [key, value] of Object.entries(data)) {
        if (Array.isArray(value)) {
            // 如果值是陣列，逐一加入並保留 `[]`
            value.forEach(item => params.append(`${key}[]`, item));
        } else {
            // 如果值不是陣列，直接加入
            params.append(key, value);
        }
    }
    return params;
};

